import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SelectPicker } from 'rsuite';
import { getOr, startCase } from 'lodash/fp';
import { useSelector } from 'react-redux';
import SearchGuestRelationModal from '../guest/SearchGuestRelationModal';
import { getRelationshipForId } from '../../redux/Guest/selectors/components/relationship';
import { parseInt } from '../../helpers/utils';

const GuestSelectPicker = ({ onSelect, ...props }) => {
  const [showModal, setShowModal] = useState(false);
  const [options, setOptions] = useState([]);
  const value = parseInt(getOr(0, 'value', props));
  const guest = useSelector(state => getRelationshipForId(state, value));

  const handleOnClick = () => {
    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
  };

  const handleSelectGuest = ({ id, firstname, lastname }) => {
    onSelect(id);
    setOptions([{ value: id, label: startCase(`${firstname} ${lastname}`) }]);
    setShowModal(false);
  };

  useEffect(
    () => {
      if (!guest || !value) return;
      const { id, firstname, lastname } = guest;
      setOptions([{ value: id, label: startCase(`${firstname} ${lastname}`) }]);
    },
    [value]
  );

  return (
    <Fragment>
      <SelectPicker
        {...props}
        data={options}
        value={value}
        searchable={false}
        menuStyle={{ display: 'none' }}
        placeholder="Search Guests"
        onClick={handleOnClick}
      />
      <SearchGuestRelationModal
        show={showModal}
        onHide={handleHideModal}
        onSelect={handleSelectGuest}
      />
    </Fragment>
  );
};

GuestSelectPicker.propTypes = {
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default GuestSelectPicker;
